import React, { createContext } from 'react';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('SSRProvider/SSRProvider');
export var SSRContext = /*#__PURE__*/createContext({
  uniqId: null
});
/**
 * Провайдер обязателен для использования, необходимо обернуть в него все приложение.
 *
 * Используется для корректного озвучивания скринридерами Radiobox и Checkbox компонент.
 */

export var SSRProvider = function SSRProvider(_ref) {
  var children = _ref.children;
  var value = {
    uniqId: 0
  };
  return /*#__PURE__*/React.createElement(SSRContext.Provider, {
    value: value
  }, children);
};